import styled from "styled-components";
import bubblebg from "../images/bubblebannerbg.png"




export const MainBannerStyled = styled.div`
    display: flex;
    width: 90%;
    flex-direction: column;
    margin: 1rem auto;
    padding: 1rem;
    gap: 0.5rem;
    justify-content: center;
    align-items: center;
    border-radius: 0.625rem;
    background:
            linear-gradient(to right, rgba(111, 203, 209, 0.8), rgba(57, 104, 107, 0.8)),
            url(${bubblebg}) center center;
    background-size: cover;
    overflow: hidden;
    .auto-type{
        color: #fff!important;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        text-align: center;
        font-family: "Kdam Thmor Pro", sans-serif!important;
        font-weight: 400;
        font-size: 1.4rem;
        font-style: normal;
    }
    
    h1,p{
        color: #fff;
    }
    .search{
        display: flex;
        justify-content: space-between;
        background: #fff;
        width: 90%;
        margin: 0 auto;
        border-radius: 0.625rem;
        padding: 1rem;
        cursor: text;
        input{
            border: none;
            width: 70%;
            outline: none;
        }
    }
    .desktopbtns{
        display: none;
    }
    .privacy{
        font-size: 0.5rem;
        color:#fff;
        text-decoration: underline;
    }

    @media only screen and (min-width: 992px) {
        
        .desktopbtns{
            display: flex;
            justify-content: center;
            margin: 1rem auto;
            gap: 1rem;
        }
        .auto-type{
            font-size: 2.5rem;
        }
        .search{
            padding: 2.5rem;
        }
    }
    
`;

export const OffersContainerStyled = styled.div`
    display: flex; 
    flex-flow: column wrap; 
    gap: 1rem; 
    margin: 1rem auto;
    @media only screen and (min-width: 992px) {
        width: 90%;
        flex-flow: row wrap;
    }

`

export const OffersDataStyled =styled.div`
    background: transparent;
    border: 1px solid #6FCBD1;
    border-radius: 0.625rem;
    position: relative;
    width: 90%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    gap: 1.7rem;
    padding: 1rem;
    height: 500px;
    h2{
        font-weight: 400;
        text-align: center;
    }
    p{
        text-align: justify;
    }
    .link {
        a {
            position: absolute;
            top: 20%;
            right: 0;
            transform: rotate(-90deg) translateY(-50%);
            transform-origin: right center;
            background: ${({theme}) => theme === 'dark' ? 'white' : '#5fbec5'};
            border: ${({theme}) => theme === 'dark' && '1px solid #fff'};
            color: ${({theme}) => theme === 'dark' ? '#5fbec5' : 'white'};;
            font-size: 0.875rem;
            font-weight: 500;
            padding: 0.5rem 1rem;
            border-top-right-radius: 1.5rem;
            border-top-left-radius: 1.5rem;
            white-space: nowrap;
            cursor: pointer;

            /* Smooth transition setup */
            max-height: 30px; /* starting height */
            overflow: hidden;
            transition: max-height 0.4s ease, background 0.3s ease, color 0.3s ease;

            &:hover {
                max-height: 33px;
            }
        }
    }
    @media only screen and (min-width: 992px) {
        flex: 1 1 22%; 
        min-width: 200px;
        h2,p{
            font-size: 1rem;
        }
    }
    
`;



export const SectionTitleStyled =styled.h2`
    text-align: center;
    font-size: 1.2rem;
    margin: 0;
    color: ${({theme})=> theme === "dark" ? '#fff' : '#39686B'};
    
`

export const TestimonialContainerStyled = styled.div`
    background: ${({theme})=> theme === "dark" ? '#40757e' : '#b5e6e9'};
    margin-top: 5rem;
    padding: 1rem;
`